import { Component } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { Customer } from "src/app/models/customer.model";
import { CustomerService } from "src/app/services/customer.service";
import { PaymentDetails } from "src/app/models/payment-details.model";
import { CustomerDetailsGeneralDataComponent } from "src/app/components/customer-details-general-data/customer-details-general-data.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: "customer-details-component",
    templateUrl: "./customer-details.component.html",
    styleUrls: ["./customer-details.component.scss"],
    imports: [ButtonModule, CardModule, CommonModule, CustomerDetailsGeneralDataComponent],
    providers: [CustomerService]
})
export class CustomerDetailsComponent {
    public customer!: Customer;
    public paymentDetails!: PaymentDetails;    

    constructor(private customerService: CustomerService) {
        this.customerService.getCustomerByNumber('K2076247-59').subscribe((customer) => {
            this.customer = customer;
        });

        this.customerService.getInvoicingInfo().subscribe((paymentDetails) => {
            this.paymentDetails = paymentDetails;
        });
    }

    getEInvoiceStatus(): string {            
        if (this.paymentDetails && [0, 1, 3].includes(this.paymentDetails.eInvoiceStatus)) {
            return "Nee";
        }    
        if (this.paymentDetails && [2, 4].includes(this.paymentDetails.eInvoiceStatus)) {
            return "Ja";
        }
        return "Onbekend";
    }

    editCustomer() {
        throw new Error('Method not implemented.');
    }
    
    editPaymentMethod() {
        throw new Error('Method not implemented.');
    }

    resetPassword() {
        throw new Error('Method not implemented.');
    }

    editInvoiceAddress() {
        throw new Error('Method not implemented.');
    }
    
    editPaymentDetails() {
        throw new Error('Method not implemented.');
    }
}